var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.firstData!='id' && _vm.firstData!='name' && _vm.firstData!='poster' && _vm.firstData!='genres')?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.firstData.toUpperCase()))]),_c('td',[_vm._v(_vm._s(_vm.secondData))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }